import { render, staticRenderFns } from "./PublicationFullReference.vue?vue&type=template&id=23fd2527&"
import script from "./PublicationFullReference.vue?vue&type=script&lang=js&"
export * from "./PublicationFullReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports